.root {
  border: 1px solid var(--mantine-color-tertiary-2);

  .placeholder {
    background: var(--mantine-color-tertiary-0);
  }
}
